import { accessGroupStaticDefaults } from './accessGroup';
import { bulkStaticDefaults } from './bulk';
import { sharedStaticDefaults } from './common';
import { deviceStaticDefaults } from './device';
import { userStaticDefaults } from './user';

export const staticDefaults = {
  user: userStaticDefaults,
  device: deviceStaticDefaults,
  accessGroup: accessGroupStaticDefaults,
  bulk: bulkStaticDefaults,
  shared: sharedStaticDefaults,
} as const;

export {
  accessGroupStaticDefaults,
  bulkStaticDefaults,
  deviceStaticDefaults,
  sharedStaticDefaults,
  userStaticDefaults,
};
